<template>
  <div>
    <component :is="modules.DestinationHero" v-if="destinationHero" v-bind="destinationHero" />
    <component :is="modules.DestinationIntro" v-if="destinationIntro" v-bind="destinationIntro" />
    <component :is="modules.DestinationDivider" v-if="destinationDivider" v-bind="destinationDivider" />
    <component :is="modules.DestinationEssentials" v-if="destinationEssentials" v-bind="destinationEssentials" />
    <component :is="modules.DestinationMembersTopPicks" v-if="destinationMembersTopPicks" v-bind="destinationMembersTopPicks" />
    <component :is="modules.PictureFeed" v-if="pictureFeed" v-bind="pictureFeed" />
    <!-- <component :is="modules.RoomsPricing" v-if="roomsPricing" v-bind="roomsPricing" />
    <component :is="modules.RoomsListing" v-if="roomsListing" v-bind="roomsListing" />
    <component :is="modules.Offers" v-if="offers" v-bind="offers" />
    <component :is="modules.TermsAndConditions" v-if="termsAndConditions && termsAndConditions.title" v-bind="termsAndConditions" />

    <component :is="modules.BuildingPlan" v-if="buildingPlan" v-bind="buildingPlan" />
    <component :is="modules.CoLivingBenefits" v-if="coLivingBenefits" v-bind="coLivingBenefits" />
    <component :is="modules.SafetyCleanliness" v-if="safetyCleanliness" v-bind="safetyCleanliness" />

    <component :is="modules.EventsListing" v-if="eventsListing" v-bind="eventsListing" />
    <component :is="modules.CoWorkingListing" v-if="coWorkingListing" v-bind="coWorkingListing" />
    <component :is="modules.PrivateHireListing" v-if="privateHireListing" v-bind="privateHireListing" />
    <component :is="modules.CurrentResidents" v-if="ctaCarousel" v-bind="ctaCarousel" />
    <component :is="modules.RestaurantsListing" v-if="restaurantsListing" v-bind="restaurantsListing" />
    <component :is="modules.RequestInterest" v-if="requestInterest" v-bind="requestInterest" />
    <component :is="modules.FindUs" v-if="findUs" v-bind="findUs" />
    <component :is="modules.LocationMap" v-if="locationMap" v-bind="locationMap" />
    <component :is="modules.Faqs" v-if="faqs" :faqs="faqsArray" /> -->
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moduleLoader from '~/utils/module-loader';
import {
  NAMESPACE,
  SET_WHITE_HEADER,
  SET_CRISIS_NOTIFICATION_ALERT,
} from '~/store/sitewide';
// import { NAMESPACE, SET_CRISIS_NOTIFICATION_ALERT } from '~/store/sitewide';

import {
  destination_hero as DestinationHero,
  destination_divider as DestinationDivider,
  destination_intro as DestinationIntro,
  destination_essentials as DestinationEssentials,
  destination_members_top_picks as DestinationMembersTopPicks,
  picture_feed as PictureFeed,
  // anchor_links as AnchorLinks,
  // location_look_around as LocationLookAround,
  // building_plan as BuildingPlan,
  // events_listing as EventsListing,
  // rooms_pricing as RoomsPricing,
  // rooms_listing as RoomsListing,
  // co_working_listing as CoWorkingListing,
  // private_hire_listing as PrivateHireListing,
  // restaurants_listing as RestaurantsListing,
  // location_map as LocationMap,
  // find_us as FindUs,
  // request_interest as RequestInterest,
  // co_living_benefits as CoLivingBenefits,
  // current_residents as CurrentResidents,
  // events_promo as EventsPromo,
  // faqs as Faqs,
  // terms_and_conditions as TermsAndConditions,
  // safety_cleanliness as SafetyCleanliness,
  // offers as Offers,
} from '~/.modules.json';

// Set modules on page

const modules = [
  DestinationHero,
  DestinationIntro,
  DestinationEssentials,
  DestinationMembersTopPicks,
  DestinationDivider,
  PictureFeed,
  // AnchorLinks,
  // LocationLookAround,
  // BuildingPlan,
  // EventsListing,
  // RoomsListing,
  // RoomsPricing,
  // CoWorkingListing,
  // PrivateHireListing,
  // RestaurantsListing,
  // FindUs,
  // LocationMap,
  // RequestInterest,
  // CoLivingBenefits,
  // CurrentResidents,
  // EventsPromo,
  // Faqs,
  // TermsAndConditions,
  // SafetyCleanliness,
  // Offers,
];

const { mapActions } = createNamespacedHelpers(NAMESPACE);

export default {
  props: {
    destinationHero: { type: Object, required: false, default: null },
    destinationIntro: { type: Object, required: false, default: null },
    destinationDivider: { type: Object, required: false, default: null },
    destinationEssentials: { type: Object, required: false, default: null },
    destinationMembersTopPicks: { type: Object, required: false, default: null },
    pictureFeed: { type: Object, required: false, default: null },
    // anchorLinks: { type: Object, required: false, default: null },
    // lookAround: { type: Object, required: false, default: null },
    // termsAndConditions: { type: Object, required: false, default: null },
    // buildingPlan: { type: Object, required: false, default: null },
    // eventsListing: { type: Object, required: false, default: null },
    // roomsListing: { type: Object, required: false, default: null },
    // roomsPricing: { type: Object, required: false, default: null },
    // coWorkingListing: { type: Array, required: false, default: null },
    // privateHireListing: { type: Array, required: false, default: null },
    // restaurantsListing: { type: Object, required: false, default: null },
    // eventsPromo: { type: Object, required: false, default: null },
    // findUs: { type: Object, required: false, default: null },
    // locationMap: { type: Object, required: false, default: null },
    // coLivingBenefits: { type: Object, default: null },
    // requestInterest: { type: Object, required: false, default: null },
    // bookingOptions: { type: Object, required: true, default: null },
    // address: { type: String, required: false, default: null },
    // ctaCarousel: { type: Object, default: null },
    title: { type: String, required: false, default: null },
    metaTitle: { type: String, required: false, default: null },
    metaDescription: { type: String, required: false, default: null },
    // safetyCleanliness: { type: Object, default: null },
    // offers: { type: Object, default: null },
    faqs: { type: Object, required: false, default: null },
    crisisNotificationAlert: { type: Object, required: false, default: null },
  },
  data: function() {
    return {
      faqsArray: null,
    };
  },
  beforeCreate() {
    this.modules = moduleLoader(modules);
  },
  created() {
    this.faqsArray = [this.faqs];
    this.SET_WHITE_HEADER(true);
  },

  beforeDestroy() {
    this.$scrollEntrance.destroy();
    this.SET_WHITE_HEADER(false);
  },
  mounted() {
    this.$scrollEntrance.mount();
    this.SET_CRISIS_NOTIFICATION_ALERT({
      crisisNotificationAlert: this.crisisNotificationAlert,
    });
  },

  methods: {
    ...mapActions([SET_WHITE_HEADER, SET_CRISIS_NOTIFICATION_ALERT]),
  },
};
</script>
